export default {
    pageTitle: 'Real Estate, Homes for Sale, MLS Listings | Movoto',
    pageDesp: 'Movoto provides customizable search tools, local market insights, and expert guidance to support you on your path toward homeownership.',
    movotorealestatelistings: 'Movoto real estate listings',
    homesforsalebystate: 'Homes for sale by state',
    stateRealEstate: '$state real estate',
    homesForSaleInState: 'Homes for sale in $state',
    popularLocations: 'Popular locations',
    buy: 'Buy',
    aHome: 'a home',
    buyAHome: 'Buy A Home',
    sell: 'Sell',
    myHome: 'my home',
    sellHome: 'Sell My Home',
    homeEstimate: 'Home Estimate',
    BuyText: 'City, ZIP, School, Address, Neighborhood...',
    sellMyHomeText: 'My Home Address',
    PriceMyHomeText: 'Enter home address...',
    weSupportYourHome: 'Built to get you home.',
    submit: 'Submit',
    RecentDesp: 'Recently viewed',
    actionItems: {
        buy: {
            title: 'Buy a home',
            description: 'Custom search, smart insights, expert agents at your finger tips.',
            cta: 'Browse homes',
        },
        sell: {
            title: 'Sell your home',
            description: 'Expert agents and smart tools to help you sell faster and smarter.',
            cta: 'Get connected',
        },
        finance: {
            title: 'Get financing',
            description: 'Financial tools and lenders to get pre-approved fast.',
            cta: 'Get pre-approved',
        },
    },
    bottomCards: {
        guide: {
            title: 'Neighborhood guide',
            description: 'Everything you need to know about neighborhoods.',
            link: 'View guides',
        },
        marketTrends: {
            title: 'Market trends',
            description: 'Explore how trends vary from market to market.',
            link: 'View trends',
        },
        schools: {
            title: 'Schools',
            description: 'Finds areas with the best districts and schools.',
            link: 'View schools',
        },
        tips: {
            title: 'Real estate tips',
            description: 'Discover all the tips, tricks, and how-tos regarding real estate.',
            link: 'View tips',
        },
    },
    welcomeHomeIsCloser: 'Welcome home is closer than you think',
    withCustomizableSearch:
        'With customizable search capabilities, tech-enabled insights, and expert guidance, Movoto gives you the tools and support you need to feel confident making your next move.',
    localLicensedVetted: 'Local, licensed, vetted',
    yourMovotoAgentWillHelp:
        'Your Movoto agent will help you create a winning offer on the home that’s right for you, and support you through the entire process — from inspection and appraisal to closing.',
    getConnected: 'Get connected',
    findOutWhatYouCanAfford: 'Find out what you can afford',
    understandHowMuchYou:
        'Understand how much you can afford with our suite of financial tools and connect with a top lender to get pre-approved so you’re ready to make an offer when the time’s right.',
    calculateMortgage: 'Calculate mortgage',
    beTheFirstToKnow: 'Be the first to know',
    customizeYourSearchAround: 'Customize your search around what matters most. We’ll send real-time listing updates so you never miss a home that fits.',
    getNotified: 'Get notified',
    yourNewHomeMightBe: 'Your new home might be waiting for you in one of these popular cities.',
    selectACityToExplore: 'Select a city to explore available homes.',
    homesForSaleInCityState: '$city, $state homes for sale',
};
